import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Draw } from 'ol/interaction';
import VectorSource from 'ol/source/Vector';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { CalculationSettingsModel, RNAVModel } from 'src/app/models/configuration';
import { docAndSectorizationDTO } from 'src/app/models/docAndSectorizationDTO';
import { FeatureType, NavaidTypes } from 'src/app/models/EnumTypes';
import { NavaidDTOCalculation, NavaidModel } from 'src/app/models/navaid';
import { SearchItem } from 'src/app/models/searchItem';
import { NavaidSitingToolComponent } from 'src/app/popup/calculations/navaid-siting-tool/navaid-siting-tool.component';
import { GenericControlService } from 'src/app/popup/services/generic-control.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { DocSectorizationDisplayService } from 'src/app/services/doc-sectorization-display.service';
import { FomCheckService } from 'src/app/services/fom-check.service';
import { GenericComponentControlService } from 'src/app/services/generic-component-control.service';
import { MapService } from 'src/app/services/map.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import { SearchService } from 'src/app/services/search.service';
import { MenuManagementService } from '../services/menu-management.service';
import { PreProcessingToolComponent } from 'src/app/popup/tools/flight-inspection/pre-processing-tool/pre-processing-tool.component';
import { TerrainGridService } from 'src/app/services/terrain-grid.service';
import { AltitudeFilterService } from 'src/app/services/altitude-filter.service';
import { AzimuthToolService } from 'src/app/map/services/azimuth-tool.service'
import { TerrainAltitudeCutComponent } from 'src/app/popup/tools/terrain-altitude-cut/terrain-altitude-cut.component';
import { HorizonToolService } from 'src/app/services/horizon-tool.service';
import { MapSearchService } from 'src/app/services/map-search.service';
import { MultipathToolService } from 'src/app/services/multipath-tool.service';
import { BarometricToolService } from 'src/app/services/barometric-tool.service';
import { CoverageAssessmentComponent } from 'src/app/popup/tools/coverage-assessment/coverage-assessment.component';
import { DistanceAzimuthService } from 'src/app/map/services/distance-azimuth.service';
import { RangeRingToolService } from 'src/app/map/services/range-ring-tool.service';
import { CrossSectionService } from 'src/app/services/cross-section.service';
import { NavaidsCoChannelsService } from 'src/app/services/navaids-co-channels.service';
import { TabsService } from 'src/app/services/tabsService';
import { Feature } from 'ol';
import { DynamicTable } from 'src/app/popup/dynamic-table/dynamic-table.component';
import { UtilsService } from 'src/app/services/utils.service';
import { NavaidsService } from 'src/app/services/navaids.service';
import { ImportControlService } from 'src/app/popup/services/import-control.service';
import { WebBrowserMapService } from 'src/app/services/web-browser-map.service';
import { IdentifyToolService } from 'src/app/services/identify-tool.service';
import { CalculationsService } from 'src/app/services/calculations.service';
import { TerrainHeightService } from 'src/app/map/services/terrain-height.service';
import { TerrainAltitudeCutService } from 'src/app/services/terrain-altitude-cut.service';
import { Procedure } from 'src/app/models/procedure';
import { VectorLayerDMTR } from '../view-menu/layer';
import { PendingCalculation, PendingCalculationType } from 'src/app/models/pendingCalculation';
import { CalculationsControlService } from 'src/app/services/calculations-control.service';
import { Geometry } from 'ol/geom';
import { ImportFormat } from 'src/app/models/importFormat';
import { SelectByFirComponent } from 'src/app/popup/select-by-fir/select-by-fir.component';

@Component({
  selector: 'app-tools-menu',
  templateUrl: './tools-menu.component.html',
  styleUrls: ['./tools-menu.component.scss'],
  standalone: false
})
export class ToolsMenuComponent implements OnInit {

  active: boolean = false;

  processingToolFormats: ImportFormat[] = ImportFormat.PROCESSING_TOOL_FORMATS;


  constructor(public menuService: MenuManagementService,
    public genericController: GenericComponentControlService,
    public genericModal: GenericControlService,
    public fomCheckService: FomCheckService,
    private pointsController: PointsService,
    private modalService: ModalControlService,
    private configurationController: ConfigurationService,
    private docSectService: DocSectorizationDisplayService,
    private popupService: BsModalService,
    public rangeRingTool: RangeRingToolService,
    public terrainGridController: TerrainGridService,
    public altitudeFilterController: AltitudeFilterService,
    public azimuthToolController: AzimuthToolService,
    public horizonToolController: HorizonToolService,
    public mapSearchController: MapSearchService,
    public multipathToolController: MultipathToolService,
    public barometricToolController: BarometricToolService,
    public distanceAzimuthService: DistanceAzimuthService,
    public crossSectionController: CrossSectionService,
    public terrainHeightController: TerrainHeightService,
    private navaidsControlService: NavaidsService,
    public tabsService: TabsService,
    public utilsService: UtilsService,
    private searchService: SearchService,
    public importService: ImportControlService,
    private webBrowserMapService: WebBrowserMapService,
    private identifyToolService: IdentifyToolService,
    private terrainAltitudeCutService: TerrainAltitudeCutService,
    private globalSelection: GlobalSelectionControlService,
    private terrainHeightService: TerrainHeightService,
    private calculationsControlService: CalculationsControlService
  ) { }



  ngOnInit(): void {
  }

  openDocAndSectorizationDisplay() {
    if (this.pointsController.getSelectedFeatures().length >= 1) {
      this.docSectService.calculateDocSectorizationDisplayInitialization();

    } else {
      this.modalService.showMesssageModal(
        'Warning',
        'Please select at least 2 NavAids'
      );
    }
  }

  openAzimuthTool() {
    this.tabsService.openNewToolsTab(TabsService.AZIMUTH_TOOL);
  }

  openRangeRingTool() {
    this.tabsService.openNewToolsTab(TabsService.RANGE_RING);
  }

  openFomCheck() {
    this.tabsService.openNewFomCheck();
  }

  showCriticalNavaids() {
    this.pointsController.getCriticalNavaids().subscribe((results: NavaidModel[]) => {
      results.forEach(navaid => {
        let feat: Feature = this.pointsController.getNavaidFeatureFromLayers(navaid.id);
        let layer: VectorLayerDMTR = this.pointsController.navaidsLayers.childLayers[0].layers.find((element) => element.id === navaid.navaidtype.toLowerCase()).olLayer;
        this.globalSelection.selectNavaidOnMap(feat, layer);
      });
      if (results.length == 0) {
        this.modalService.showMesssageModal("Show Critical Navaids", "There is no critical navaids to display.");
      }
    });
  }

  openAltitudeFilter() {
    this.tabsService.openNewToolsTab(TabsService.ALTITUDE_FILTER);
  }

  openBarometricToolController() {
    this.tabsService.openNewToolsTab(TabsService.BAROMETRIC_CALCULATION_TOOL);
  }

  openTerrainGrid() {
    this.tabsService.openNewToolsTab(TabsService.TERRAIN_GRID);
  }

  openHorizonTools() {
    this.tabsService.openNewToolsTab(TabsService.HORIZON_TOOL);
    //this.horizonToolController.openWindow();
  }

  openMapSearch() {
    this.tabsService.openNewToolsTab(TabsService.MAP_SEARCH)
  }

  openCrossSection() {
    this.tabsService.openNewToolsTab(TabsService.CROSS_SECTION)
  }

  distanceAndAzimuth() {
    this.globalSelection.clearAllSelectedTools();
    this.distanceAzimuthService.activeDistanceAzimuth();
  }

  activateWebBrowser(mapType: string) {
    this.webBrowserMapService.openWindow(mapType);
    //window.open("https://www.google.com", '_blank').focus();
  }

  activateIdentifyTool() {
    this.globalSelection.clearAllSelectedTools();
    this.identifyToolService.activateTool();
    //window.open("https://www.google.com", '_blank').focus();
  }

  openMultipathTool() {
    let navaidFeatures: Feature[] = this.pointsController.getSelectedFeaturesOfType(FeatureType.Navaid);
    if (navaidFeatures.length == 0) {
      this.modalService.showMesssageModal("Warning", "Select at least 1 Navaid to edit.");
      return;
    }
    let navaid: NavaidModel;
    if (navaidFeatures.length > 1) {
      const bsModalRef: BsModalRef = this.popupService.show(DynamicTable, {
        backdrop: 'static' // Prevent closing on backdrop click
      });
      bsModalRef.content.entity = "Navaids";
      bsModalRef.content.type = "Edit";
      bsModalRef.content.selectAllActive = false;
      bsModalRef.content.data = navaidFeatures;
      bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Navaids");
      bsModalRef.content.onClose.subscribe(result => {
        if (result.length == 1) {
          let feature: any = this.pointsController.getSelectedFeatures().find(feat => feat.get("id") == result[0].id && feat.get("featureType") == FeatureType.Navaid);
          navaid = this.pointsController.transformFeatureInNavaid(feature)
          this.tabsService.openNewMultipathTool(navaid);
        }
      });
    } else {
      navaid = this.pointsController.transformFeatureInNavaid(navaidFeatures[0])
      this.tabsService.openNewMultipathTool(navaid);
    }
  }

  showHiddenMenu(evt) {
    if (evt.srcElement.classList.contains('create')) {
      evt.srcElement.children[0].classList.add('createHiddenMenu', 'active');
    }
  }

  closeHiddenMenu(evt) {
    if (document.querySelector('.createHiddenMenu.active, .dotsHiddenMenu.active') != null) {
      document.querySelector('.createHiddenMenu.active, .dotsHiddenMenu.active').classList.remove('createHiddenMenu', 'active', 'dotsHiddenMenu')
    }
  }

  openTerrainAltitudeCut() {
    this.globalSelection.clearAllSelectedTools();
    this.terrainAltitudeCutService.openTerrainAltitudeCut();
    //const bsModalRef: BsModalRef = this.popupService.show(TerrainAltitudeCutComponent);
  }

  openCoverageAssessmentTool() {
    if (this.pointsController.getSelectedFeatures().length >= 1) {
      let navaidsCounter = 0;
      this.pointsController.getSelectedFeatures().forEach((element) => {
        if (element.getProperties().featureType == FeatureType.Navaid) {
          navaidsCounter++;
        }
      });
      if (navaidsCounter >= 1) {
        const bsModalRef: BsModalRef = this.popupService.show(CoverageAssessmentComponent);
      } else {
        this.modalService.showMesssageModal(
          'Warning',
          'Please select at least 1 NavAids'
        );
      }
    } else {
      this.modalService.showMesssageModal(
        'Warning',
        'Please select at least 1 NavAids'
      );
    }
  }

  openNavaidsCoChannel() {
    this.tabsService.openNewNavaidsCoChannelCheck();
  }

  terrainHeighAtPoint() {
    this.globalSelection.clearAllSelectedTools();
    this.terrainHeightService.activeTerrainHeight();

  }

  openSelectionByFir() {
    this.globalSelection.clearAllSelectedTools();
    this.popupService.show(SelectByFirComponent);
  }
}
